// React hook for delaying calls with time
// returns callback to use for cancelling
// callback - if you create a new callback each render, then previous callback will be canceled on render.
// timeout - delay, ms (default: immediately put into JS Event Queue)
import { useEffect, useCallback, useRef } from "react";

export const useTimeout = (
  callback: () => void,
  timeout: number = 0
): (() => void) => {
  const timeoutIdRef = useRef<NodeJS.Timeout>();

  const cancel = useCallback(() => {
    const timeoutId = timeoutIdRef.current;

    if (timeoutId) {
      timeoutIdRef.current = undefined;
      clearTimeout(timeoutId);
    }
  }, [timeoutIdRef]);

  useEffect(() => {
    timeoutIdRef.current = setTimeout(callback, timeout);

    return cancel;
  }, [callback, timeout, cancel]);

  return cancel;
};
